import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { MantineMenu } from '@dealstack/frontend/shared/components/MantineMenu/MantineMenu.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { GENERIC_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds.ts';
import { Text, useMantineTheme } from '@mantine/core';
import { MantineMenuItemProps } from '@dealstack/frontend/shared/components/MantineMenu/MantineMenu.types';

interface Props {
	securities: MantineMenuItemProps[];
	disabled?: boolean;
}

export const RankSecurityDropdown = ({ securities, disabled = false }: Props) => {
	const tCapManage = useTranslationCapManage();
	const mantineTheme = useMantineTheme();

	return (
		<MantineMenu
			dataTestId={GENERIC_ELEMENT_ID.RANK_SECURITY_DROPDOWN}
			position="bottom-end"
			hideArrow={true}
			menuProps={{
				withinPortal: true,
			}}
			targetButtonProps={{
				disabled,
				style: {
					display: 'grid',
					placeItems: 'center',
					width: '28px',
					height: '28px',
					border: `1px solid ${mantineTheme.colors.gray[4]}`,
					padding: 0,
				},
			}}
			targetContent={
				<Icon
					variant="plus"
					size="md"
					style={{
						color: mantineTheme.colors.dark[9],
					}}
				/>
			}
			dropdownTopContent={
				<Text
					style={{
						borderBottom: `1px solid ${mantineTheme.colors.gray[2]}`,
					}}
					p="xs"
					c="gray.9"
				>
					{tCapManage('rankSecurityDropdown.unrankedDropdownTitle')}
				</Text>
			}
			items={securities}
		/>
	);
};
